export default "__VITE_ASSET__BaHPIS27__"